var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loader",style:(_vm.getStyle)},[(_vm.content == undefined || _vm.content == null)?_c('div',{staticClass:"loading",class:_vm.getClass}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }